import { Injectable } from '@angular/core';

@Injectable()
export class UtilsService {

	constructor() {
		//
    }
    
    redondear(numero:number, decimales:number){
        let flotante = parseFloat(numero.toString());
        let resultado = Math.round(flotante * Math.pow(10,decimales)) / Math.pow(10,decimales);
        return resultado;
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/services/utils.service.ts